export const translationsDashboard_da_part2 = {
  assignedTo: "Tildelt til",
  assignedToMe: "Tildelt til mig",
  assignedToYou: "Tildelt til dig",
  unassign: "Fjern tildeling",
  unassigned: "Ikke tildelt",
  unknownUser: "Ukendt bruger",
  resolutionRate: "Løsningsrate",
  handoverRequiredRate: "Kræver kundeservice",
  fallbackRate: "Fallback rate",
  userRequestedCustomerServiceRate: "Bruger bad om kundeservice",
  resolutionCategoryContained: "Løst uden kundeservice",
  resolutionCategoryHandoverRequired: "Krævede kundeservice",
  resolutionCategoryFallback: "Fallback",
  resolutionCategoryCustomerRequestedService: "Bruger bad om kundeservice",
  resolutionCategoryFilterApplied: "Viser samtaler med",
  commentsLabel: "Kommentarer",
  noComments: "Ingen kommentarer endnu",
  usernamePlaceholder: "Dit navn",
  addCommentPlaceholder: "Tilføj en kommentar...",
  addComment: "Tilføj kommentar",
  adding: "Tilføjer...",
  editComment: "Rediger kommentar",
  deleteComment: "Slet kommentar",
  confirmDeleteComment: "Er du sikker på, at du vil slette denne kommentar?",
  save: "Gem",
  cancel: "Annuller",
  commentPlaceholder: "Kommentar",
  unreadComments: "Ulæste kommentarer",
  uploadingImage: "Uploader billede...",
  imageUploadFailed: "Kunne ikke uploade billede.",
  reportImageAlt: "Rapportbillede",
  removeImage: "Fjern billede",
  uploadImage: "Upload billede",
  mentionedConversationsFilter: "Omtaler af mig",
  mentionFilterEmpty: "Ingen uløste rapporter, hvor du er nævnt, matcher dine filtre.",
  mentionAllTeam: "@all",
  mentionAllTeamHint: "Alle i organisationen",
  mentionSomeone: "Nævn en kollega",
  insertEmoji: "Indsæt emoji",
  mentionReportParticipant: "Deltager i denne rapport",
  adminUnreadCommentsMarker: "Admins: der er ulæste kommentarer i dette filter",
  markAllUnreadCommentsRead: "Markér alle som læst",
  markingUnreadCommentsRead: "Markerer...",
  unreadMentionBadge: "Ulæst omtale af dig",
  mentionFeatureAnnouncementTitle: "Nyt: Tildel og tag kolleger",
  mentionFeatureAnnouncementP1:
    "I fejlrapporten kan du tildele samtalen til en kollega eller bruge @ i kommentarfeltet for at omtale bestemte personer.",
  mentionFeatureAnnouncementP2:
    "Brug @all for hele organisationen. Ulæste, uløste rapporter du følger vises i filteret, og du kan rydde gamle ulæste kommentarer samlet.",
  mentionFeatureAnnouncementOk: "Forstået",
  mentionFeatureAnnouncementDontShowAgain: "Vis ikke denne besked igen",
  // Product button translation
  // Product button translation
  viewProduct: "SE PRODUKT",
  companyInfo: "Virksomhedsinformation",
  livechat: "Livechat",
  // Context chunks translations
  // Context chunks translations
  showContext: "Vis kontekst kilder",
  hideContext: "Skjul kontekst kilder",
  loadingContextChunks: "Indlæser kontekst...",
  noContextChunks: "Ingen kontekst information tilgængelig for denne besked.",
  contextUsed: "Kontekst brugt til at generere dette svar:",
  source: "Kilde",
  relevance: "relevans",
  contextChunkOriginUploaded: "Uploadet",
  contextChunkOriginScrapedPage: "Scrapet side",
  page: "Side",
  conversationUnavailable: "Denne samtale er slettet eller ikke længere tilgængelig for dig.",
  // AI debug data translations (admin only)
  // AI debug data translations (admin only)
  showAiDebug: "Vis AI debug info",
  hideAiDebug: "Skjul AI debug info",
  loadingAiDebug: "Indlæser AI debug info...",
  noAiDebug: "Ingen AI debug information tilgængelig for denne besked.",
  aiDebugTitle: "AI Debug Information",
  urlValidatorLabel: "URL-validering rettelser",
  vectorStoreLabel: "Vector store",
  vectorStorePgvector: "pgvector",
  searchMethodLabel: "Søgemetode",
  searchMethodKeywordFallback: "Søgeordssøgning · automatisk fallback",
  searchMethodKeywordFallbackDescription:
    "Embedding af spørgsmålet fejlede eller fik timeout. Dette svar brugte pgvector-søgeordssøgning i stedet for semantisk søgning.",
  searchMethodKeywordOnly: "Søgeordssøgning · valgt i flow",
  searchMethodKeyword: "Søgeordssøgning",
  searchMethodSemantic: "Semantisk søgning",
  llmProviderLabel: "LLM-udbyder",
  llmProviderVertex: "Google Vertex",
  llmProviderBedrock: "AWS Bedrock",
  llmProviderOpenai: "OpenAI",
  llmFallbackReasonLabel: "LLM fallback-årsag",
  fallbackReasonLabel: "Retrieval fallback-årsag",
  rephraseLabel: "Omformuleret spørgsmål",
  fordelingsflowLabel: "Fordelingsflow resultat",
  metadataFiltersLabel: "Metadata filtre",
  hardcodedMetadataFilterLabel: "Hardcoded metadata filter",
  noRephrase: "Ingen omformulering (første besked eller hilsen)",
  noFordelingsflow: "Ingen fordelingsflow udført",
  agentExecutionLogLabel: "Integration handling (før streaming)",
  noMetadataFilters: "Ingen metadata filtre anvendt",
  noHardcodedMetadataFilter: "Ingen hardcoded metadata filter",
  metadataFilterSuccessBanner: "Filter returnerede resultater",
  hardcodedFilterFellBackLabel: "Hardcoded filter faldt tilbage til ufiltreret søgning:",
  hardcodedFilterFellBackBanner:
    "Hardcoded filter returnerede ingen resultater - faldt tilbage til ufiltreret søgning",
  hardcodedFilterSuccessBanner: "Hardcoded filter returnerede resultater",
  topicFilterApplied: "Filtreret efter emne",
  purchaseFilterApplied: "Viser samtaler med køb",
  leadsFilterApplied: "Viser leads",
  timePeriod: "Tidsperiode",
  timePeriodAll: "Alle",
  timePeriodToday: "I dag",
  timePeriodYesterday: "I går",
  timePeriodThisWeek: "Denne uge",
  timePeriodLast7Days: "Sidste 7 dage",
  timePeriodThisMonth: "Denne måned",
  timePeriodLast30Days: "Sidste 30 dage",
  timePeriodFilterApplied: "Filtreret efter tidsperiode",
  filterApplied: "Filter anvendt",
  uploadData: "Upload Data",
  editSubject: "Rediger emne",
  selectSubject: "Vælg emne...",
  open: "Åben",
  closed: "Lukket",
  leads: "Kontaktformular",
  testConversation: "Test Samtale",
  sessionContext: "Sessionskontekst",
  conversationProductClicked: "Klik på produkt",
  conversationLinkClicked: "Klik på link",
  conversationNoRecordedClicks: "Ingen registrerede klik",
  draftUsageWordsRetained:
    "{{matched}} af {{draft}} ord fra udkastet i et svar på {{response}} ord",
  emailSenderAgent: "Kundeservice",
  emailSenderAgentVia: "Sendt fra {{provider}}",
  emailSenderDraft: "AI-udkast",
  emailSenderDraftDescription: "Forslag til svar, ikke sendt til kunden",
  emailSenderNote: "Intern note",
  emailSenderNoteDescription: "Ikke synlig for kunden",
  emailSenderSent: "Sendt af automatisering",
  emailSenderSentDescription: "AI-svar sendt automatisk til kunden",
  emailDraftUsageReply: "{{percentage}}% match med AI-udkastet",
  verifiedMetadataLabel: "Verificerede kundedata",
  sessionMetadataLabel: "Sessionsmetadata",
  sessionMetadataUnverified: "Ikke verificeret",
  sessionMetadataHint: "Leveret af den besøgendes browser. Disse værdier er ikke verificeret.",
  sessionMetadataConversationEmail: "Email oplyst før samtalen",
  verifiedMetadataHint:
    "Signeret af kundens website og verificeret af os, så oplysningerne kan stoles på.",
  fieldTypeTextarea: "Tekstområde",
  deviceLabel: "Enhed",
  deviceDesktop: "Computer",
  deviceTablet: "Tablet",
  devicePhone: "Mobil",
  deviceNotRecorded: "Ikke registreret",
};
